import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  ErrorHandler,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { AppComponent } from './app/app.component.js';
import { routes } from './app/app.routes.js';
import { AuthService } from './app/core/auth/auth.service.js';
import { environment } from './environments/environment.js';
import { SentryErrorHandler } from './app/core/sentry-error-handler.js';

console.log(
  `fieldpilot-web (sha: ${environment.gitSha}, env: ${environment.environmentName}) loaded`,
);

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.environmentName,
    release: environment.gitSha,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    // Strip PII — no URL params, no form data, no customer names
    beforeSend(event: Sentry.ErrorEvent) {
      if (event.request) {
        delete event.request.query_string;
        delete event.request.data;
        delete event.request.cookies;
      }
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      return event;
    },
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAppInitializer(() => inject(AuthService).init()),
    ...(environment.sentryDsn ? [{ provide: ErrorHandler, useClass: SentryErrorHandler }] : []),
  ],
}).catch((err) => {
  console.error('Failed to bootstrap web app', err);
});
